import React, { useState, useEffect } from "react";
import About from "./About";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import { PublicUserInfo } from "../../../../Auth/Helper";
import moment from "moment";

export default function ConsultantRole({ setIsProfileEditing }) {
  const { userid } = useParams();
  const userId = userid ? userid : localStorage.getItem("userId");
  const navigate = useNavigate()

  const [details, setDetails] = useState({
    about: "",
    industry: "",
    industryExperience: "",
    username: "",
    portfolio: "",
    location: "",
    linkedin: "",
    name: "",
    profilePhoto: null,
    resume: null,
    skills: [],
  });

  useEffect(() => {
    PublicUserInfo({ userId: userId })
      .then((res) => {
        setDetails({
          ...details,
          ...res.data.result,
          location:
            res.data.result?.state != null && res.data.result?.country != null
              ? res.data.result?.state + ", " + res.data.result?.country
              : "",
          name: `${res.data.result?.firstName ?? ""} ${res.data.result?.lastName ?? ""
            }`.trim(),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className={`font-[Roboto] ${userid && "p-8"}`}>
      <div className="flex">
        <div className="flex flex-col bg-white lg:w-full pb-12">
          <div
            style={{
              height: "155px",
              left: "291px",
              top: "145px",
              background: "#2EBAA3",
              borderRadius: "8px",
            }}
          ></div>
          <div className="flex">
            <div className="flex flex-col pl-11 pr-11 space-x-2 space-y-2">
              <div className="flex md:mx-0 -mt-12 mx-auto h-48 w-48">
                {details.profilePhoto ? (
                  <img src={details.profilePhoto} alt="profilephoto" />
                ) : (
                  <img
                    alt="Consultant"
                    className="h-36 w-36 -mt-12 sm:ml-16 rounded-full"
                    src="https://t3.ftcdn.net/jpg/05/17/79/88/360_F_517798849_WuXhHTpg2djTbfNf0FQAjzFEoluHpnct.jpg"
                  />
                )}
              </div>
              <div className="flex flex-col sm:text-start text-center">
                <span>
                  {details?.name.charAt(0).toUpperCase() +
                    details?.name.slice(1)}
                </span>
                <span className="mt-1 text-xs">
                  {"Joined : " + moment(details?.createdAt).format("DD/MM/YYYY")}
                </span>
                {/* <span className="text-sm text-gray-500">
                  IT Services and IT Consulting
                </span> */}
              </div>
            </div>
            <Sidebar details={details} />
          </div>
          <div className="flex items-center space-x-4 pl-11">
            {userId === localStorage.getItem("userId") && (
              <button
                onClick={() => {
                  navigate("/dashboard/my-account/edit")
                }}
                className="sm:mt-0 mt-4 text-sm space-x-8 px-2"
                style={{
                  height: "35px",
                  background: "#139588",
                  borderRadius: "10px",
                  color: "white",
                }}
              >
                Edit Profile
              </button>
            )}
          </div>
        </div>
      </div>
      <About details={details} />
    </div>
  );
}
